export const CONTENT_STATUSES = {
    PUBLISHED: 1,
    DRAFT: 2,
    SCHEDULED: 3,
}